import React from "react";

import { useGetFormattedEmployeeDataQuery } from "EmployerApplication/api";
import { isRenewal } from "QuotePage/urls";
import { useSelector } from "react-redux";

import { Body2 } from "Cobalt/BodyText";
import { getSelectedMedicalPlans, getSelectedDentalPlan, getSelectedVisionPlan } from "Common/CartService";
import Icon from "Common/Icon";
import InfoPopover from "Common/InfoPopover";

import { LifePlanEligibilityMessage, uhcCarrierNames } from "./LifePlanEligibility";

const useShowLifePlanEligibilityWarning = ({ plan }) => {
  const selectedDentalPlan = useSelector((state) => getSelectedDentalPlan(state));

  const selectedVisionPlan = useSelector((state) => getSelectedVisionPlan(state));

  const selectedMedicalPlans = useSelector((state) => getSelectedMedicalPlans(state));

  const hasMedicalPlansWithUHC = [...selectedMedicalPlans].some((plan) => uhcCarrierNames.includes(plan?.carrier));

  const hasDentalPlanWithUHC = uhcCarrierNames.includes(selectedDentalPlan?.carrier);

  const hasVisionPlanWithUHC = uhcCarrierNames.includes(selectedVisionPlan?.carrier);

  const employeeProfile = useSelector((state) => state.employeeProfile);

  const { data } = useGetFormattedEmployeeDataQuery();
  const formattedEmployeeData = data?.formatted_employee_data || [];
  const numberOfEmployees = isRenewal() ? formattedEmployeeData.length : employeeProfile.length;

  const show = uhcCarrierNames.includes(plan.carrier) && numberOfEmployees < 6 && !(hasMedicalPlansWithUHC || (hasDentalPlanWithUHC && hasVisionPlanWithUHC));

  return { show };
};

const LifePlanEligibilityWarning = ({ plan, text, ...rest }) => {
  const { show } = useShowLifePlanEligibilityWarning({ plan });
  if (show) {
    return (
      <>
        <Body2 componentClass="span" weight="bold" color="warning" {...rest}>
          {text || "Life Plan Eligibility"}
        </Body2>{" "}
        <InfoPopover infoText={LifePlanEligibilityMessage} displayComponent={<Icon icon="question-circle" />} />
      </>
    );
  }
  return null;
};

export default LifePlanEligibilityWarning;
